import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "newProject",
  "use": "newProject-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 12\" id=\"newProject\">\n<path d=\"M9.5,3.3L6.3,0.1C6.2,0.1,6.1,0,6,0H1C0.4,0,0,0.4,0,1V11c0,0.5,0.4,1,1,1h7.7c0.5,0,1-0.4,1-1V3.6C9.6,3.5,9.5,3.4,9.5,3.3\n\tz M6.2,3.8C6,3.8,5.8,3.6,5.8,3.4V0.9l2.9,2.9H6.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol